<template>
  <w-tooltip color="border">
    <template #tooltip-activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
      >
        <w-table-chips
          v-for="(item, index) of visibleItems"
          :key="index"
        >
          {{ item }}
        </w-table-chips>
      </div>
    </template>
    <template #tooltip>
      {{ tooltip }}
    </template>
  </w-tooltip>
</template>
<script>
import { truncate } from '@/services/truncate-service';

export default {
  name: 'WorkTableChipsWrapper',
  props: {
    value: { type: [Array, Object], default: () => [] },
    truncateAfter: { type: Number, default: 2 },
  },
  computed: {
    tooltip() {
      return this.value?.join(', ');
    },
    visibleItems() {
      return truncate(this.value, this.truncateAfter);
    },
  },
};
</script>
